import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Select } from '@ngxs/store';
import { UiState } from '@ngxs-store/ui-store/ui.state';
import { Observable } from 'rxjs';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@core/animations/route.animations';

@Component({
  selector: 'app-authorization-denied-page',
  template: `
  <div class="page" fxLayout="column" fxFill fxLayoutAlign="center center">
    <mat-card [ngClass]="routeAnimationsElements" [ngClass]="{'full-width': isMobileMode$ | async, 'half-width': (isMobileMode$ | async) === false}" [class.mat-elevation-z24]="'true'">
      <app-authorization-denied [theme]="theme$ | async"></app-authorization-denied>
    </mat-card>
  </div>
  `,
  styles: [
    `



      .full-width {
        width: 100%;
      }

      .half-width {
        width: 30%;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthorizationDeniedPageComponent implements OnInit {
  @Select(UiState.getTheme) theme$: Observable<string>;
  @Select(UiState.getIsMobileMode) isMobileMode$: Observable<boolean>;

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  constructor() { }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {
  }
}
